import React from 'react';
import { cn } from '@/utils';
import Facebook from '@/svgs/facebook.svg?react';
import Github from '@/svgs/github.svg?react';
import Google from '@/svgs/google.svg?react';

type SocialButtonProps = {
  className?: string;
  children?: React.ReactNode;
  href: string;
  type?: 'google' | 'facebook' | 'github';
};

const SocialButton: React.FC<SocialButtonProps> = ({
  className,
  children,
  type,
  ...rest
}) => {
  const classMap = {
    google: 'bg-white text-brand-dark-100',
    facebook: 'bg-[#1877F2] text-white',
    github: 'bg-brand-dark-50 text-white',
  };

  const childMap = {
    google: (
      <>
        <Google /> Google
      </>
    ),
    facebook: (
      <>
        <Facebook /> Facebook
      </>
    ),
    github: (
      <>
        <Github className="h-5 w-5" /> Github
      </>
    ),
  };
  return (
    <a
      className={cn(
        'flex items-center justify-center gap-x-2 rounded-lg px-3.5 py-2.5 text-lg font-medium hover:bg-opacity-70',
        type && classMap[type],
        className,
      )}
      {...rest}
    >
      {children ? children : type ? childMap[type] : ''}
    </a>
  );
};

export default SocialButton;
